import React, { useState } from "react";
import { IndianCardGamesData as Data } from "../../../constants/Casino/IndianCardGamesData";
import { useDispatch, useSelector } from "react-redux";
import { setLoginNew } from "../../../store/LoginNew/loginNew.slice";
import { setLoginNavigationData } from "../../../store/loginNavigation/LoginNavigation.slice";
import { useNavigate } from "react-router-dom";
import { openSlotCasinoPopUp } from "../../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { USER_DATA } from "../../../config/app.config";
import { toastr } from "react-redux-toastr";
import { storeUserData } from "../../../helpers/payloadSetter";

const IndianCardGameGridList = ({ seeAll }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [showLoginBtn_At, setShowLoginBtn_At] = useState("");

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const onClickGame = (item, item_index, tab_Index) => {
    if (user) {
      if (userData?.is_demo) {
        toastr.error("", "Please login from your read ID.");
        return;
      }

      if (item?.tested) {
        navigate(`/table-casino-live/${item?.eventName}`);
      } else {
        const gameId = item?.gameId;
        const tableId = item?.tableId || null;

        storeUserData(userData?._id, item);
        navigate(`/casino-live/${gameId}/${tableId}`);
        dispatch(openSlotCasinoPopUp());
      }
    } else {
      setShowLoginBtn_At(`${item.name}_${item_index}_${tab_Index}`);
    }
  };

  const handleLogin = (item) => {
    dispatch(setLoginNew(true));
    if (item?.tested) {
      dispatch(
        setLoginNavigationData({
          page: "table-casino-live",
          ids: [item?.eventName],
        })
      );
    } else {
      dispatch(
        setLoginNavigationData({
          page: "casino-live",
          ids: [item?.gameId, item?.tableId || null],
        })
      );
    }
  };

  return (
    <div
      className={`grid  ${
        seeAll ? "grid-cols-4 md:grid-cols-6" : " grid-rows-3 grid-flow-col"
      }  gap-1 w-max md:w-full`}
    >
      {Data[0].length > 0
        ? Data[0].map((item, index) => {
            if (
              item?.name == "32 Card B" &&
              window?.location?.hostname?.includes("sbgwinbuzz.in")
            )
              return null;

            return (
              <div
                key={item?.id}
                className={`${!seeAll ? "min-w-[120px] sm:min-w-[140px] md:min-w-[160px] lg:min-w-[180px] xl:min-w-[200px] 2xl:min-w-[220px]" : "w-auto"} flex aspect-square flex-col items-center justify-center  cursor-pointer transition-all ease-in-out duration-100`}
              >
                <div 
                className={`${!seeAll ? "min-w-[120px] sm:min-w-[140px] md:min-w-[160px] lg:min-w-[180px] xl:min-w-[200px] 2xl:min-w-[220px]" : "w-auto"} aspect-square max-w-[120px] sm:max-w-[140px] md:max-w-[160px] lg:max-w-[180px] xl:max-w-[200px] 2xl:max-w-[220px] bg-transparent flex flex-col transition-all ease-in-out duration-200 relative overflow-hidden rounded-[4px]`}>
                  <div
                    className={`${!seeAll ? "min-w-[120px] sm:min-w-[140px] md:min-w-[160px] lg:min-w-[180px] xl:min-w-[200px] 2xl:min-w-[220px]" : "w-auto"} aspect-square`}
                    onClick={() => {
                      onClickGame(item, index, 0);
                    }}
                  >
                    <img
                      src={item.image_1}
                      width="500"
                      height="auto"
                      className="w-full h-full object-cover rounded-[6px] hover:scale-[103%] transition-all ease-in-out duration-200"
                      alt={item.name}
                      loading="lazy"
                      title={item.name}
                    />
                  </div>

                  {!user && showLoginBtn_At == `${item.name}_${index}_0` && (
                    <div className="absolute bg-bg_Ternary14 shadow-[0 4px 30px rgba(0, 0, 0, 0.1)] w-full h-full text-text_Quaternary text-center flex items-center justify-center z-[100] top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 backdrop-blur-2">
                      <button
                        className="inline-block  leading-normal relative overflow-hidden  transition ease-in-out bg-bg_Quaternary text-text_Secondary px-5 shadow-innerLogin py-1.5 popupAnimation duration-100 rounded-[16px] text-xs font-lato font-bold  cursor-pointer"
                        type="button"
                        onClick={() => {
                          handleLogin(item);
                        }}
                      >
                        Login
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default IndianCardGameGridList;
